// 资料中转重定向（供模型组拼接稳定链接：businessType + businessId）
export default {
  meta: { localeModules: ['report', 'comment', 'summary', 'aiChat'] },
  path: '/material',
  redirect: (to) => ({ path: '/material/redirect', query: to.query }),
  children: [
    {
      // 中转页：仅做环境判断与路由解析后重定向到真实详情页
      path: 'redirect',
      name: 'materialRedirect',
      component: () => import(/* webpackChunkName: 'material-redirect' */ '@/pages/materialRedirect/index.vue'),
      meta: {
        keepAlive: false
      }
    }
  ]
};
